export class MainLanding {
    topVideoSlides: anm.BgVideoSlide[] = [
        {
            videoUrl: 'https://videos.animatron.com/landing/main/2product_wave_low.mp4',
            title: 'any.landing.top.title2',
            subtitle: 'any.landing.top.subtitle2',
            description: 'any.landing.top.description2',
            btnName: 'any.landing.top.button2',
            btnUrl: '/wave/landing'
        },
        {
            videoUrl: 'https://videos.animatron.com/landing/main/slider_studio.mp4',
            title: 'any.landing.top.title1',
            subtitle: 'any.landing.top.subtitle1',
            description: 'any.landing.top.description1',
            btnName: 'any.landing.top.button1',
            btnUrl: '/studio/landing'
        }
    ]
}

angular.module('animatronApp.mainLanding', []).component('mainLanding', {
    controller: MainLanding,
    templateUrl: require('landing/main-landing.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/mainLanding.ts